// WaitingPanel — "Waiting on TMC", shown at the top of Dream Team for staff: client messages nobody at TMC has
// answered for more than N working hours (SAST 08:00–17:00 weekdays). Clears itself when staff reply in that channel,
// or when someone at TMC marks it "No reply needed" (for everyone).
import { useEffect, useState } from "react";
import { InboxApi } from "../hooks/useApi.js";

const age = (h) => (h >= 9 ? `${Math.floor(h / 9)}d ${Math.round(h % 9)}h` : `${Math.round(h * 10) / 10}h`);

export default function WaitingPanel({ onOpen }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    let live = true;
    const load = () => InboxApi.waiting().then((d) => { if (live) setData(d); }).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    return () => { live = false; clearInterval(t); };
  }, []);
  const dismiss = (w) => {
    // Optimistic: drop it (and anything older in that channel — the server clears those too).
    setData((d) => d && { ...d, items: d.items.filter((x) => x.messageId !== w.messageId) });
    InboxApi.dismissWaiting(w.messageId).catch(() => InboxApi.waiting().then(setData).catch(() => {}));
  };
  if (!data || !data.items?.length) return null;
  return (
    <div className="waiting-panel" role="status">
      <button type="button" className="waiting-panel__head" onClick={() => setOpen((o) => !o)}>
        ⏳ Waiting on TMC <b>{data.items.length}</b>
        <span className="waiting-panel__hint">client messages with no reply for {data.threshold}+ working hours</span>
        <span className="waiting-panel__chev">{open ? "▾" : "▸"}</span>
      </button>
      {open && data.items.map((w) => (
        <div key={w.messageId} className="waiting-panel__row">
          <button type="button" className="waiting-panel__open" onClick={() => onOpen(w)}>
            <span className="waiting-panel__age">{age(w.workingHours)}</span>
            <span className="waiting-panel__main">
              <span className="waiting-panel__where"><b>{w.channelName}</b>{w.clientName ? ` · ${w.clientName}` : ""} · {w.senderName}</span>
              <span className="waiting-panel__text">{w.snippet}</span>
            </span>
          </button>
          <button type="button" className="waiting-panel__dismiss" onClick={() => dismiss(w)}
                  title="Mark as handled for everyone at TMC">✓ No reply needed</button>
        </div>
      ))}
    </div>
  );
}
